import jQuery from 'jquery';
import $ from 'jquery';

window.jQuery = jQuery;
window.$ = jQuery;

import whatInput from 'what-input';
import Foundation from 'foundation-sites';
// import datepicker from 'foundation-datepicker';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below

// import './lib/foundation-explicit-pieces';

$(document).foundation();

/**
* @app Burger Menu Functions
* @desc Breaks the content of an element to the specified number of words
* @version 1.0.0
* @license The MIT License (MIT)
* @author WMC
*/
$(document).ready(function () {
	$('.burger, .overlay').click(function(){
		$('.burger').toggleClass('clicked');
		$('.overlay').toggleClass('show');
		$('.main-nav').toggleClass('show');
		$('body').toggleClass('overflow');
	});
});

/**
* @app Burger Menu ActiveLink
* @desc Breaks the content of an element to the specified number of words
* @version 1.0.0
* @license The MIT License (MIT)
* @author WMC
*/
//$(document).ready(function () {
//  $('#mainnav a[href^="/' + location.pathname.split("/")[1] + '"]').addClass('alink');
//  $('#sub-main a[href^="/' + location.pathname.split("/")[1] + '"]').addClass('alink');
//  $('#subnav a[href^="/' + location.pathname.split("/")[1] + '"]').addClass('alink');
//});

/**
* @app Heading Animation
* @desc Breaks the content of an element to the specified number of words
* @version 1.0.0
* @license The MIT License (MIT)
* @author WMC
*/
$(document).ready(function () {
	$('.heading').toggleClass('heading-animation');
});

/**
* @app ScrollDown-JS
* @desc Breaks the content of an element to the specified number of words
* @version 1.0.0
* @license The MIT License (MIT)
* @author WMC
*/
$(function(){$('a[href*="#"]:not([href="#"])').click(function(){if(location.pathname.replace(/^\//,"")==this.pathname.replace(/^\//,"")&&location.hostname==this.hostname){var a=$(this.hash);if(a=a.length?a:$("[name="+this.hash.slice(1)+"]"),a.length)return $("html, body").animate({scrollTop:a.offset().top},400),!1}})});

/**
* @app ScrollTop-JS
* @desc Breaks the content of an element to the specified number of words
* @version 1.0.0
* @license The MIT License (MIT)
* @author WMC
*/
$(document).ready(function(a){$(window).scroll(function(){$(this).scrollTop()>=400?$("#scroll_top").fadeIn(225):$("#scroll_top").fadeOut(225)}),$("#scroll_top").click(function(){return $("body,html").animate({scrollTop:0},800),!1})});

/**
* @app Rent TAB
* @desc Breaks the content of an element to the specified number of words
* @version 1.0.0
* @license The MIT License (MIT)
* @author WMC
*/
$('[data-open-details]').click(function (e) {
  e.preventDefault();
  $(this).next().toggleClass('is-active');
  $(this).toggleClass('is-active');
});


